module.exports = __webpack_public_path__ + "img/arrow-error.764f43cc.svg";